import AoneService from "../axiosbase";
//update single cod
export const updateSingleCod = async (params,data) => {
  try {
    return await AoneService.put(`orders/api/v1/orders/cod/${params}`,data);
  } catch (error) {
    return error;
  }
};
//import bulk cod
export const importCod = async (data) => {
  try {
    return await AoneService.post(`orders/api/v1/orders/cod/upload`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
//template for cod update
export const codUpdateTemplate = async () => {
  try {
    return await AoneService.get(
      `orders/api/v1/orders/cod/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//import bulk destination address
export const importDesAddress = async (data) => {
  try {
    return await AoneService.patch(`orders/api/v1/consignments/destination-address`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
//template for destination address
export const desAddressUpdateTemplate = async () => {
  try {
    return await AoneService.get(
      `orders/api/v1/consignments/destination-address/template`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//import origin address
export const importOriginAddress = async (data) => {
  try {
    return await AoneService.patch(`orders/api/v1/consignments/origin-address`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
export const exportConsignments = async (params) => {
  try {
    return await AoneService.get("orders/api/v1/consignments/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
export const exportPostConsignments = async (params) => {
  try {
    return await AoneService.post("orders/api/v1.1/consignments/export" , params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//export packages print
export const exportPackageWaybill = async (params) => {
  try {
    return await AoneService.get(`orders/api/v2/orders/print/package/${params}` , {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//update bulk cod
export const updateBulkCod = async (data) => {
  try {
    return await AoneService.put(`orders/api/v1/orders/cod`,data);
  } catch (error) {
    return error;
  }
};
//get customer sequencer
export const getCustomerSequencer = async (params) => {
    try {
      return await AoneService.get(`orders/api/v1/customer/sequencers${params}`);
    } catch (error) {
      return error;
    }
  };
  //export sequencer
  export const exportCustomerSequencer = async (params) => {
    try {
      return await AoneService.get(`orders/api/v1/customer/sequencers/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//post Customer sequencer
export const postCustomerSequencer = async (data) => {
    try {
      return await AoneService.post("orders/api/v1/customer/sequencers", data);
    } catch (error) {
      return error;
    }
  };
//actiavate/deactivate customer sequence
export const activateCustomerSequencer = async (params,data) => {
    try {
      return await AoneService.patch(`orders/api/v1/customer/sequencers/${params}/status`,data);
    } catch (error) {
      return error;
    }
  };
  //lookup for status
  export const getSequencerStatus = async () => {
    try {
      return await AoneService.get(`orders/api/v1/lookups/CustomerSequencerStatus`);
    } catch (error) {
      return error;
    }
  };

  //export consignment events
  export const exportConsignmentEvents = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/events/consignment/${params}/export` , {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //export package events
  export const exportPackageEvents = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/events/packages/${params}/export`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //export all packages
  export const exportAllPackageEvents = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/events/consignment/${params}/packages/export`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //download consignment proofs
  export const downloadConsignmentProof = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/events/${params}/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
  //download signature proofs
  export const downloadSignaturesProof = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/events/${params}/signature/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
  //download delivery proofs
  export const downloadDeliveryProof = async (params) => {
    try {
      return await AoneService.get(`orders/api/v1/consignments/${params}/delivery-proof/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
  export const downloadPaymentProof = async (params) => {
    try {
      return await AoneService.get(`orders/api/v1/consignments/${params}/payment-proof/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
  export const downloadSignatureProof = async (params) => {
    try {
      return await AoneService.get(`orders/api/v1/consignments/${params}/signature/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
  //download package proofs
  export const downloadPackagesProof = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/events/package/${params}/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
//get package
export const getPackage = async (params) => {
  try {
    return await AoneService.post("orders/api/v1.1/packages" + params);
  } catch (error) {
    return error;
  }
};
//export
export const exportPackage = async (params) => {
  try {
    return await AoneService.get("orders/api/v1/packages/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//Bad Address
export const getBadAddressbyFilter = async (params) => {
  try {
    return await AoneService.get(`orders/api/v1/bad-address/filter${params}`);
  } catch (error) {
    return error;
  }
};
export const getBadAddressWaybillList = async (params) => {
  try {
    return await AoneService.get(`orders/api/v1/bad-address/waybill-list-page${params}`);
  } catch (error) {
    return error;
  }
};
//export waybill list
 export const exportBadAddressWaybillList = async (params) => {
   try {
     const response = await AoneService.get(
       `orders/api/v1/bad-address/export${params}`, 
       { responseType: "blob" }
     );
     return response;
   } catch (error) {
     return error;
   }
 };
export const deleteBadAddress = async (params) => {
  try {
    return await AoneService.delete(`orders/api/v1/bad-address?trackingId=${params}`);
  } catch (error) {
    return error;
  }
};
//get bad address waybill details
export const getBadAddressWaybill = async (params) => {
  try {
    return await AoneService.get(`orders/api/v1/bad-address/waybill-detail?trackingId=${params}`);
  } catch (error) {
    return error;
  }
};
//address change
export const changeDesAddress = async (params,data) => {
  try {
    return await AoneService.patch(`orders/api/v2/address/changes/${params}/destination-address`,data);
  } catch (error) {
    return error;
  }
};
export const changeDestinationAddress = async (params,data) => {
  try {
    return await AoneService.patch(`orders/api/v2/consignments/${params}/destination-address`,data);
  } catch (error) {
    return error;
  }
};
//get consignment address change history
export const getAddressChangeHistory = async (params) => {
  try {
    return await AoneService.get(`orders/api/v2/address/changes/${params}/history`);
  } catch (error) {
    return error;
  }
};
//category
  export const getBadAddressCategory = async () => {
    try {
      return await AoneService.get(`orders/api/v1/lookups/BadAddressCategory`);
    } catch (error) {
      return error;
    }
  };
//subcategory
  export const getBadAddressSubcategory = async () => {
    try {
      return await AoneService.get(`orders/api/v1/lookups/BadAddressSubCategory`);
    } catch (error) {
      return error;
    }
  };
    export const getShipmentType = async () => {
    try {
      return await AoneService.get(`orders/api/v1/lookups/BadAddressShipmentType`);
    } catch (error) {
      return error;
    }
  };
//resolve by shortaddress
  export const resolveByShortAddress = async (params) => {
    try {
      return await AoneService.get(`addresses/api/v1/address/resolve/short-address/${params}`);
    } catch (error) {
      return error;
    }
  };
    //resolve shortaddress version 2
    export const resolveByShortAddressV2 = async (params) => {
    try {
      return await AoneService.get(`addresses/api/v3/address/resolve/short-address/${params}`);
    } catch (error) {
      return error;
    }
  };
  //resolve by geocode
    export const resolveByGeoCode = async (param,param2) => {
    try {
      return await AoneService.get(`addresses/api/v1/address/resolve/geocode?lat=${param}&lng=${param2}`);
    } catch (error) {
      return error;
    }
  };  
  //consignment address change history
    export const consignmentAddressHistory = async (params) => {
    try {
      return await AoneService.get(`/orders/api/v2/address/changes/${params}/history`);
    } catch (error) {
      return error;
    }
  };  
  //consignment history 2.0
      export const consignmentAddressHis = async (params) => {
    try {
      return await AoneService.get(`/orders/api/v1/bad-address/location-history${params}`);
    } catch (error) {
      return error;
    }
  };
  //location history 2.0
        export const consignmentLocationHistory = async (data) => {
    try {
      return await AoneService.post(`/consignee/api/consignees`,data);
    } catch (error) {
      return error;
    }
  };
   export const getPaymentType = async () => {
    try {
      return await AoneService.get(`orders/api/v1/lookups/PaymentType`);
    } catch (error) {
      return error;
    }
  };
//get edd date
export const getEstimatedDate = async (params) => {
  try {
    return await AoneService.get(`ops/api/v2/consignments/${params}`);
  } catch (error) {
    return error;
  }
};
//RECONCILE
export const postReconcileOrder = async (data) => {
    try {
      return await AoneService.post("ops/api/v1/consignments/reconcile/creation", data);
    } catch (error) {
      return error;
    }
  };

  //VALIDATE SHORTADDRESS
  export const validateShortAddress = async (data) => {
    try {
      return await AoneService.post("orders/api/v1/short-address/validate", data);
    } catch (error) {
      return error;
    }
  };
  //Notify bad address
  export const notifyBadAddress = async (data) => {
    try {
      return await AoneService.post(`orders/api/v1/bad-address/notify/${data}`);
    } catch (error) {
      return error;
    }     
  };

  //Update bad address
  export const updateBadAddress = async (params, data) => {
    try {
      return await AoneService.patch(`orders/api/v1/bad-address/${params}`, data);      
    } catch (error) {
      return error;
    }
  };

export const deleteCacheEntry = async (trackingId) => {
  try {
    return await AoneService.delete(`ops/api/v1/consignments/cache/${trackingId}`);
  } catch (error) {
    return error;
  }
};

export const postOrderConsignmentsReconcile = async (data) => {
  try {
    return await AoneService.post("orders/api/v1/consignments/reconcile", data);
  } catch (error) {
    return error;
  }
};